var _mask, _g, _mask2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWeblinkRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 10,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 1.5H10.4998V10.4998H1.5V1.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50167 9.5017H2.49803V2.49806H5.99985V1.49988H2.49803C1.94698 1.49988 1.49985 1.94701 1.49985 2.49806V9.5017C1.49985 10.0532 1.94698 10.4999 2.49803 10.4999H9.50167C10.0523 10.4978 10.4978 10.0523 10.4998 9.5017V5.99988H9.50167V9.5017Z",
    fill: "#E2001B"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 8,
    height: 8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88068 1.5H10.5V8.11909H3.88068V1.5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99836 1.5V2.49818H8.79427L3.88068 7.41545L4.58472 8.11909L9.50158 3.20591V5.00182H10.5002V1.5H6.99836Z",
    fill: "#E2001B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeblinkRed);
export default __webpack_public_path__ + "static/media/icon_weblink_red.91f563c4549b957c168cc7b2cdf294a1.svg";
export { ForwardRef as ReactComponent };